const intervalOfAttempts = ( value, vm ) => {
    if ( !value || !vm.validationParameter )
        return true;

    const numberOfAttempts = vm.validationParameter;

    // Transformar string de intervalos em array
    const intervalOfAttemptsArray = value.split( ', ' );

    // Verificar se todos os elementos do array são números inteiros.
    const allIntervalsAreValid = intervalOfAttemptsArray.every( interval => Number.isInteger( parseInt( interval, 10 ) ) );

    // Verificar se a quantidade de elementos do array e o mesmo número do limite de tentativas - 1
    const arraySizeIsValid = intervalOfAttemptsArray.length === parseInt( numberOfAttempts, 10 ) - 1;

    // Se todas as validações passarem, os intervalos são validos
    return allIntervalsAreValid && arraySizeIsValid;
};

export default {
    intervalOfAttempts
};